/**
 * <product-recommendations> — fetches Shopify's recommendations for this product and swaps in the
 * section the server rendered for them, so the list and its markup come from the same place as
 * every other server-rendered part of the theme.
 */
class ProductRecommendations extends HTMLElement {
  connectedCallback() {
    if (this.dataset.loaded) return;
    // only fetch once the section is near the viewport; it sits well below the fold
    this.observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        this.observer.disconnect();
        this.load();
      },
      { rootMargin: '600px' },
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  async load() {
    this.dataset.loaded = 'true';
    try {
      const response = await fetch(this.dataset.url, { cache: 'no-store' });
      const markup = await response.text();
      const parsed = new DOMParser().parseFromString(markup, 'text/html');
      const next = parsed.querySelector('product-recommendations');
      if (next) this.innerHTML = next.innerHTML;
    } catch {
      // recommendations are an enhancement; leaving the section empty is the right failure
    }
  }
}

if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', ProductRecommendations);
}
